// src/src/utils/api.js
import apiHandler from "./api/apiHandler";

const ping = async () => {
  return new Promise((resolve, reject) => {
    apiHandler
      .get("/pilot/ping")
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAvatarUrl = (id, size) => {
  if (id == "") return "";
  if (id == "system")
    return import.meta.env.PAGE_URL + "/icons/system_avatar.png";
  if (id !== undefined)
    return (
      import.meta.env.API_URL + "/pilot/avatar/" + id + (size ? "_" + size : "")
    );
  else return import.meta.env.API_URL + "/pilot/avatar";
};

const getBannerUrl = (id) => {
  if (id == "") return "";
  return import.meta.env.API_URL + "/airline/banner/" + id;
};

const getLogoUrl = (id, size) => {
  if (id == "") return "";
  return (
    import.meta.env.API_URL + "/airline/logo/" + id + (size ? "_" + size : "")
  );
};

const getAwardImageUrl = (id, size) => {
  if (id == "") return "";
  return (
    import.meta.env.API_URL + "/award/image/" + id + (size ? "_" + size : "")
  );
};

const getPostImageUrl = (id) => {
  if (id == "") return "";
  return import.meta.env.API_URL + "/feed/image/" + id;
};

import apiAirlines from "./api/apiAirlines";
import apiAirport from "./api/apiAirport";
import apiAwards from "./api/apiAwards";
import apiCharter from "./api/apiCharter";
import apiExpenses from "./api/apiExpenses";
import apiFeed from "./api/apiFeed";
import apiFlights from "./api/apiFlights";
import apiMetadata from "./api/apiMetadata";
import apiPilots from "./api/apiPilots";
import apiPublic from "./api/apiPublic";
import apiSchedules from "./api/apiSchedules";
import apiSimBrief from "./api/apiSimBrief";
import apiSSO from "./api/apiSSO";
import apiSubscriptions from "./api/apiSubscriptions";

export {
  apiHandler,
  ping,
  getAvatarUrl,
  getBannerUrl,
  getLogoUrl,
  getAwardImageUrl,
  getPostImageUrl,
  apiPilots,
  apiPublic,
  apiAirlines,
  apiAwards,
  apiCharter,
  apiExpenses,
  apiFeed,
  apiFlights,
  apiMetadata,
  apiAirport,
  apiSchedules,
  apiSimBrief,
  apiSSO,
  apiSubscriptions,
};
